import React, { useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import "./Gallery.css";

const CATERING_IMAGE_COUNT = 5;
const cateringImages = Array.from({ length: CATERING_IMAGE_COUNT }, (_, i) => `/gallery/catering/catering_img${i + 1}.jpeg`);
const DECO_IMAGE_COUNT = 5;
const decoImages = Array.from({ length: DECO_IMAGE_COUNT }, (_, i) => `/gallery/deco/deco_img${i + 1}.jpeg`);
const CANOPY_IMAGE_COUNT = 5;
const canopyImages = Array.from({ length: CANOPY_IMAGE_COUNT }, (_, i) => `/gallery/canopy/canopy_img${i + 1}.jpeg`);

const albums = [
  {
    title: "Catering Events",
    cover: cateringImages[0],
    images: cateringImages
  },
  {
    title: "Decorations",
    cover: decoImages[0],
    images: decoImages
  },
  {
    title: "Canopy Services",
    cover: canopyImages[0],
    images: canopyImages
  },
];

const Gallery = () => {
  const { t } = useTranslation();
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [slides, setSlides] = useState([]);
  const [startIndex, setStartIndex] = useState(0);

  const openAlbum = (images) => {
    const formatted = images.map((src) => ({ src }));
    setSlides(formatted);
    setStartIndex(0);
    setLightboxOpen(true);
  };

  return (
    <section id="gallery" className="gallery-section py-5">
      <Container>
        <h2 className="section-title text-center mb-5" data-aos="fade-up">
          {t("gallery.title")}
          <div className="underline"></div>
        </h2>
        <Row className="g-4">
          {albums.map((album, idx) => (
            <Col md={4} key={idx}>
              <Card
                className={`album-card h-100 ${idx === 1 ? "album-card--featured" : ""}`}
                onClick={() => openAlbum(album.images)}
              >
                <Card.Img variant="top" src={album.cover} />
                <div className="album-caption">{album.title}</div>
              </Card>
            </Col>
          ))}
        </Row>

        <Lightbox
          open={lightboxOpen}
          close={() => setLightboxOpen(false)}
          slides={slides}
          index={startIndex}
          on={{ view: ({ index }) => setStartIndex(index) }}
        />
      </Container>
    </section>
  );
};

export default Gallery;